module.exports = __webpack_public_path__ + "img/branch-particle-03.e3bfe870.png";